import { render, staticRenderFns } from "./processTaskRuleDetail.vue?vue&type=template&id=439bcf56&"
import script from "./processTaskRuleDetail.vue?vue&type=script&lang=js&"
export * from "./processTaskRuleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports